<template>
    <div class="money-search-bar-container">
        <div class="from-currency-container">
            <div class="word-container hd-16 white">
                {{$t('web.travel-money.i-will-pay')}}
            </div>
            <div class="input-container">
                <input @input="calToCurrencyAmount" class="input" v-model="fromCurrencyAmount" type="text" :placeholder="$t('web.travel-money.search-bar-placeholder')">
                <div class="select">
                    <select @change="checkFromCurrencySelector" v-model="fromCurrency">
                        <option :value="currency" v-for="currency in currencies">{{currency.acronym.toUpperCase()}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="exchange-reverse">
            <a @click="currencyExchange" class="reverse-button">
                <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.875 4.28125C17.0312 4.125 17.0312 3.90625 16.875 3.75L13.75 0.625C13.5938 0.46875 13.3438 0.46875 13.2188 0.625L12.5938 1.25C12.4375 1.375 12.4375 1.625 12.5938 1.78125L14.1875 3.25H1.375C1.15625 3.25 1 3.4375 1 3.625V4.375C1 4.59375 1.15625 4.75 1.375 4.75H14.1875L12.5938 6.25C12.4375 6.40625 12.4375 6.65625 12.5938 6.78125L13.2188 7.40625C13.3438 7.5625 13.5938 7.5625 13.75 7.40625L16.875 4.28125ZM1.09375 10.2812L4.21875 13.4062C4.375 13.5625 4.625 13.5625 4.75 13.4062L5.375 12.7812C5.53125 12.6562 5.53125 12.4062 5.375 12.25L3.78125 10.75H16.625C16.8125 10.75 17 10.5938 17 10.375V9.625C17 9.4375 16.8125 9.25 16.625 9.25H3.78125L5.375 7.78125C5.53125 7.625 5.53125 7.375 5.375 7.25L4.75 6.625C4.625 6.46875 4.375 6.46875 4.21875 6.625L1.09375 9.75C0.9375 9.90625 0.9375 10.125 1.09375 10.2812Z" fill="white"/>
                </svg>
            </a>
        </div>
        <div class="to-currency-container">
            <div class="word-container hd-16 white">
                {{$t('web.travel-money.i-will-get')}}
            </div>
            <div class="input-container">
                <input @input="calFromCurrencyAmount" class="input" v-model="toCurrencyAmount" type="text" :placeholder="$t('web.travel-money.search-bar-placeholder')">
                <div class="select">
                    <select @change="checkToCurrencySelector" v-model="toCurrency">
                        <option :value="currency" v-for="currency in currencies">{{currency.acronym.toUpperCase()}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="search-button-container">
            <button @click="quoteMoney" class="search-button button hd-18 white" v-bind:class="{'is-loading': isLoading}">
                <i class="fas fa-search hd-16"></i>
                {{$t('web.travel-money.search-button')}}
            </button>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            currencies: Array,
            from_currency: String,
            from_amount: String,
            to_currency: String,
            to_amount: String
        },

        data(){
            return {
                fromCurrencyAmount: "",
                toCurrencyAmount: "",
                fromCurrency: {},
                toCurrency:{},
                isLoading: false,
            }
        },

        computed: {
        },

        methods: {
            calToCurrencyAmount(){
                this.fromCurrencyAmount = this.fromCurrencyAmount.split(',').join('');
                this.toCurrencyAmount = this.toCurrencyAmount.split(',').join('');

                if (this.fromCurrency.acronym === 'hkd') {
                    this.toCurrencyAmount = (this.fromCurrencyAmount / this.toCurrency.sell_ref_rate).toFixed();
                } else if (this.toCurrency.acronym === 'hkd'){
                    this.toCurrencyAmount = (this.fromCurrencyAmount * this.fromCurrency.buy_ref_rate).toFixed();
                }
                if (this.toCurrencyAmount === '0'){
                    this.toCurrencyAmount = '';
                }
                this.fromCurrencyAmount = this.fromCurrencyAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
                this.toCurrencyAmount = this.toCurrencyAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');

            },
            calFromCurrencyAmount(){
                this.fromCurrencyAmount = this.fromCurrencyAmount.split(',').join('');
                this.toCurrencyAmount = this.toCurrencyAmount.split(',').join('');

                if (this.fromCurrency.acronym === 'hkd') {
                    this.fromCurrencyAmount = (this.toCurrencyAmount * this.toCurrency.sell_ref_rate).toFixed();
                } else if (this.toCurrency.acronym === 'hkd'){
                    this.fromCurrencyAmount = (this.toCurrencyAmount / this.fromCurrency.buy_ref_rate).toFixed();
                }

                if (this.fromCurrencyAmount === '0'){
                    this.fromCurrencyAmount = '';
                }
                this.fromCurrencyAmount = this.fromCurrencyAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
                this.toCurrencyAmount = this.toCurrencyAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
            },
            currencyExchange(){
                let temp = this.fromCurrency;
                this.fromCurrency = this.toCurrency;
                this.toCurrency = temp;
            },
            checkFromCurrencySelector(){
                if (this.fromCurrency.acronym !== "hkd"){
                    this.toCurrency = this.currencies.find(currency => {
                        return currency.acronym === "hkd";
                    });
                }
            },
            checkToCurrencySelector(){
                if (this.toCurrency.acronym !== "hkd"){
                    this.fromCurrency = this.currencies.find(currency => {
                        return currency.acronym === "hkd";
                    });
                }
            },
            quoteMoney(){
                if (this.fromCurrencyAmount == '' || this.toCurrencyAmount == '') {
                    return false
                }
                const url = new URL(window.location.href = window.location.protocol + "//" + window.location.host + "/travel-money-quote");
                // const paramString = new URLSearchParams({
                //     from: this.fromCurrency.acronym,
                //     to: this.toCurrency.acronym,
                //     amount: this.toCurrencyAmount
                //
                // });
                this.isLoading = true;
                if (this.fromCurrency.acronym === 'hkd') {
                    window.location.href = url + "/" + this.fromCurrency.acronym + "/" + this.fromCurrencyAmount.split(',').join('') + "/" + this.toCurrency.acronym + "/" + this.toCurrencyAmount.split(',').join('');
                } else {
                    window.location.href = url + "/" + this.fromCurrency.acronym + "/" + this.fromCurrencyAmount.split(',').join('') + "/" + this.toCurrency.acronym + "/" + this.toCurrencyAmount.split(',').join('');
                }

            }
        },

        mounted() {
            if (this.from_currency !== '') {
                this.fromCurrency = this.currencies.find(currency => {
                    return currency.acronym === this.from_currency
                });
                this.toCurrency = this.currencies.find(currency => {
                    return currency.acronym === this.to_currency;
                });
                this.fromCurrencyAmount = this.from_amount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
                this.toCurrencyAmount = this.to_amount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
            } else {
                this.fromCurrency = this.currencies.find(currency => {
                    return currency.acronym === 'hkd';
                });
                this.toCurrency = this.currencies.find(currency => {
                    return currency.acronym === 'jpy';
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .money-search-bar-container{
        display: flex;
        align-items: flex-end;
        @include responsive(){
            display: block;
        }
        .word-container{
            margin-bottom: 8px;
        }
        .from-currency-container{
            @include responsive(){
                margin-bottom: 8px;
            }

            .input-container{
                display: flex;
                width: 266px;
                height: 64px;
                @include responsive(){
                    width: 100%;
                }
                input{
                    height: 100%;
                    border-radius: 8px 0 0 8px;
                    border: transparent;
                }
                .select{
                    height: 100%;
                    select{
                        height: 100%;
                        border: transparent;
                        border-radius: 0 8px 8px 0;
                    }
                }
            }
        }
        .to-currency-container{
            @include responsive(){
                margin-top: -20px;
            }
            .input-container{
                display: flex;
                width: 266px;
                height: 64px;
                @include responsive(){
                    width: 100%;
                }
                input{
                    height: 100%;
                    border-radius: 8px 0 0 8px ;
                    border: transparent;
                }
                .select{
                    height: 100%;
                    select{
                        height: 100%;
                        border: transparent;
                        border-radius: 0 8px 8px 0;
                    }
                }
            }
        }
        .exchange-reverse{
            display: flex;
            align-items: center;
            height: 64px;
            margin: 0 8px;
            @include responsive(){
                justify-content: center;
                height: unset;
            }
            .reverse-button{
                border-radius: 50%;
                background-color: #59D876;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 36px;
                height: 36px;
                @include responsive(){
                    transform: rotate(90deg);
                }
            }
        }
        .search-button-container{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            margin-left: 8px;
            @include responsive(){
                margin: 16px 0;
            }
            button{
                background: #59D876;
                border-radius: 8px;
                height: 64px;
                width: 123px;
                border-color: transparent;
                @include responsive(){
                    width: 100%;
                }
                &:hover{
                    color: #FFF;
                }
                .fas{
                    margin-right: 8px;
                }
            }
        }
    }


</style>
